"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankTransactionType = void 0;
var BankTransactionType;
(function (BankTransactionType) {
    BankTransactionType["InvoiceReceipt"] = "InvoiceReceipt";
    BankTransactionType["Payment"] = "Payment";
    BankTransactionType["Transfer"] = "Transfer";
    BankTransactionType["Deposit"] = "Deposit";
    BankTransactionType["Withdrawal"] = "Withdrawal";
    BankTransactionType["BankCharge"] = "BankCharge";
    BankTransactionType["Interest"] = "Interest";
    BankTransactionType["OpeningBalance"] = "OpeningBalance";
    BankTransactionType["Other"] = "Other";
})(BankTransactionType = exports.BankTransactionType || (exports.BankTransactionType = {}));
